'use strict'

class GroupsFormCtrl {

    constructor ($state, $stateParams, Group, $mdToast, $templateCache, $http, $scope) {

        this.$templateCache = $templateCache
        this.$state = $state
        this.$scope = $scope
        this._Group = Group
        this.buttonDisabled = false
        this.$mdToast = $mdToast
        this.$http = $http
        this.$stateParams = $stateParams
        // this.pluralize = pluralize;

        this.selectedUsers = {}
        this.usersArray = []

        this.formdata = {
            active: true
        }

        /// PAGINATOR ///
        this.pagination = {
            current: 1
        }

        //this.$scope.$on('made_new_user', this.addCreatedUser.bind(this));

        if ($stateParams.id) {

            Group.get({ id: $stateParams.id }, (data) => {
                data.users.map((user) => (
                    this.usersArray.push(user)
                ))
                angular.extend(this.formdata, data)

                delete this.formdata.users
            })
        }
    }

    //this date transform the custom date to 'new Date' so it can be re-used
    makeDate (date) {
        return new Date(date)
    }

    userSearch (query) {
        if (!query) {
            return []
        }

        return this.$http.get('/users/search/' + encodeURIComponent(query)).then(response => {
            return response.data
        })
    }

    cancel () {
        this.$state.go('groups')
    }

    save ($valid) {

        if (!$valid) {
            return
        }

        this.buttonDisabled = true

        let modelData = angular.copy(this.formdata)
        modelData['users'] = this.usersArray.map(u => u.id)

        this._Group.save(modelData, (data) => {
            //Clear cached Template
            this.$templateCache.remove('/partial/app.partials.group.detail')

            if (this.formdata.id) {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.saved?object=Group&title=' + this.formdata.title,
                    hideDelay: 3000,
                    position: ('top right')
                })

                this.$state.go('groups.update', { id: data.id }, { 'reload': true })

            } else {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.create?object=Group&title=' + this.formdata.title, //@trans('labels.group')
                    hideDelay: 3000,
                    position: ('top right')
                })

                this.$state.go('groups.update', { id: data.id }, { 'reload': true })
            }
        })
    }

    isUpdate () {
        return this.formdata.id ? true : false
    }

}

GroupsFormCtrl.$inject = ['$state', '$stateParams', 'Group', '$mdToast', '$templateCache', '$http', '$scope']

module.exports = GroupsFormCtrl
